// extracted by mini-css-extract-plugin
export default {"label":"Input_label__USfA6","input":"Input_input__iSIPy"};